import { selectorFamily } from "recoil";
import { layerRequiresGis2TokenSelector } from "./layerRequiresGis2TokenSelector";

export const layerGroupRequiresLogin = selectorFamily({
  key: "layer-group-requires-login",
  get:
    (layerIDs) =>
    ({ get }) => {
      const layersRequireGis2Token = layerIDs.map((layerID) =>
        get(layerRequiresGis2TokenSelector(layerID))
      );

      return layersRequireGis2Token.some((requires) => requires);
    },
});
